import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../../styles/icons/default.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#10ae96',
    className: null,
};

const WolfGreen = ({ color, className }) => (
    <svg
        className={classNames([styles.container, { [className]: className !== null }])}
        width="616"
        height="620.1"
        viewBox="0 0 616 620.1"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill={color}
            d="M584.1,189.7c1-29.1-15.4-72.9,12.6-91.7,11.7-7.9,14.2-10.8,19.3-22.9-1.6-1.9-2.8-4.6-4-6.7-.6-1-1.7-1.4-2.4-1.2-14.4,3.5-28.7,6.3-42.9,10.3,20.4-15.7,43.3-40.8,24-66,0-.2.3-.2.3-.4-.9-3.8-2.2-6.2-6.3-9-3.2-2.1-4.9-2.2-8.5-2.1-4.9,1.4-8.1,6.8-10.1,8.7-19.8,16.7-43.9,52.4-86.5,43.5-13-2.7-59.9,22.8-58.1,43.7-17.1,25.4-38.6,41-64.8,55.1-1.6.9-2.1,6.2-.2,7.1,18.2,8.9,31.2,11.9,51.2,9.5-15,28.9-32,56.1-52.3,81.7,1.8,1,3.6,1.9,5.4,2.9-8,10.3-16,20.3-26.1,28.6,1.9.9,4.2,1.4,5.7,2.7-15.9,10.2-37.5,25.7-51.2,36.7-28.8,23-56.8,39.5-86.4,59.6,3.2,31-38.6,78.1-58.2,100.8,1.6,1.9,3.3,3.8,5,5.7-11.8,30.7-24.6,67.4-52.4,87.3,2,1.6,4,3.2,6,4.8-18.8,3-37.1-.6-55.9-1,0,1.4.3,2.3,1.4,3.2-16.3,1.6-32.5,3.5-48.5,6.8,51.4,34.4,133.2,51.9,179.6.3.4.1.3,0,0,0,7.8,13.2-9.8,8.1,13.3,16.7,23.1,8.6,49.8,4.9,81.3,7.4,31.5,2.4,101.8,3.4,131.9-8.5,4.8-1.9,3.7-10-.9-20.5-4.5-10.6-21.1-6.8-30.3-4.9-9.1,1.9-44,7.8-48.6,1-7.1-10.6,28.3-22.2,33.8-32,1.6-2.8,9.4-12.6,9.4-17.8,13.2-6.6,32.7-15.9,43.2-23.9,22.5-17.2,31.1-35.8,39.9-60.9,1.5,13.8,3.3,27.4,4.2,41.1,1.3.1,2.2-.2,3.1-1,4.9,16.8,5.1,34.2,8.9,51.2.4-1.7.9-3.1,2.9-3.3.3,3.2,1.8,5.8,1.9,9.3.8,17.1,3,51.7,20.4,58.3,17.3,6.6,40.8-.3,53.1-4.8,12.4-4.5,8.8-9.1,6.5-16.2-2.3-7.1-10-8.1-16.6-10.1-6.6-2-11.6,1.7-19.1-3.3-6.6-4.4-12.3-17.6-12-26.6.1-2.8,2.8.5,3.9,1-2.6-9.6-5.8-15-5-25.9.6-8,1.5-20.3,2.3-29,1.4,0,2.6.2,3.9-.5.7-12.3.6-24.7,1.8-36.9.3-2.6,1-3.7,3.1-1.8-.6-6.7-.6-16-.1-22.2.8-10,2-17.5,3.7-26.9,4.6,6.9,6.6,14.1,7.6,22.1,5.3-13.9,9.7-33.2,11.5-46.7,1.7-13.5,4.2-18.6,9.6-29.7,2.8,3.7,5.9,4.6,10.3,4.8,5-32.5,10.6-64.9,18-96.9,1.8,1.2,3.5,2.5,5.4,3.6,3.6-20.7,1.5-43.6,2.2-64.1ZM455.6,410.1s0,0,0,0c0,0,0-.2,0-.2,0,0,0,.1,0,.1Z"
        />
    </svg>
);

WolfGreen.propTypes = propTypes;
WolfGreen.defaultProps = defaultProps;

export default WolfGreen;
